import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/AnalyticsScrollingSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/AuthAwareEmbedCTA.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/AuthAwareEmbedHero.jsx");
;
import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/components/landing/BenefitsCardsSection.module.css");
;
import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/(site)/LandingPageClient.module.css");
;
import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/components/landing/DeferredLooksSection.jsx");
;
import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/components/landing/EmbedFeaturesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/EmbedFeaturesTable.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/EmbedPricingSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/LandingFooter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/MoreFeaturesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/PlayerThemesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/ScrollingFeaturesSection.jsx");
